import { useState } from 'react';
import { MarkdownContent } from './MarkdownContent';

type MarkdownGuidanceFieldProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  disabled?: boolean;
  hint?: string;
};

export function MarkdownGuidanceField({
  label = 'O que se espera (Markdown)',
  value,
  onChange,
  rows = 6,
  disabled = false,
  hint = 'Use Markdown para orientar o avaliador (títulos, listas, negrito, links).',
}: MarkdownGuidanceFieldProps) {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className="md:col-span-2">
      <div className="mb-1 flex flex-wrap items-center justify-between gap-2">
        <label className="erp-label mb-0">{label}</label>
        <button
          type="button"
          className="erp-btn-secondary text-xs"
          onClick={() => setShowPreview((current) => !current)}
        >
          {showPreview ? 'Editar' : 'Pré-visualizar'}
        </button>
      </div>
      <p className="mb-2 text-xs text-secondary-500">{hint}</p>
      {showPreview ? (
        <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-3">
          <MarkdownContent value={value} emptyLabel="Nada para pré-visualizar." />
        </div>
      ) : (
        <textarea
          className="erp-input font-mono text-sm"
          rows={rows}
          disabled={disabled}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={'Ex.:\n## Critérios\n- **Nota 3**: atende o esperado\n- **Nota 5**: é referência para o time'}
        />
      )}
    </div>
  );
}
